import React from "react";
import { Link, useNavigate } from "react-router-dom";

const LanguageCourses: React.FC = () => {
  const navigate = useNavigate();

  const handleProtectedClick = (e: React.MouseEvent) => {
    const user = localStorage.getItem("user");
    if (!user) {
      e.preventDefault();
      alert("Silakan Login atau Daftar terlebih dahulu untuk mengakses kelas!");
      navigate("/auth/Login");
    }
  };

  return (
    <section className="py-20 lg:py-28 bg-[#FDFDFD] w-full font-montserrat relative">
      <div className="max-w-[1340px] mx-auto px-6 sm:px-8 lg:px-12">
        {/* Header Section (Frame 8) */}
        <div
          className="flex flex-col items-center text-center max-w-[580px] mx-auto mb-12 lg:mb-16"
          data-aos="fade-up"
        >
          {/* Badge Programs */}
          <div className="inline-flex items-center px-3 py-1 bg-[#FEE6E6] border border-[#C60302] rounded-full mb-4">
            <span className="font-poppins text-xs font-normal text-[#C60302]">
              Programs
            </span>
          </div>

          {/* Judul Utama */}
          <h2 className="font-montserrat font-bold text-3xl sm:text-4xl lg:text-[40px] text-[#202020] leading-[1.2] tracking-tight mb-4">
            Program & Learning Level
          </h2>

          {/* Subtitle */}
          <p className="font-montserrat font-normal text-base sm:text-lg lg:text-[20px] text-[#6A6A6A] leading-[1.4]">
            Designed to help you learn Indonesian gradually, according to your abilities.
          </p>
        </div>

        {/* Card Grid Layout 2 Kolom (Frame 9 & Frame 10) */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 xl:gap-10 items-stretch justify-center max-w-[1260px] mx-auto">
          {/* ================= CARD 1: Private Class (1-on-1) ================= */}
          <div
            className="relative bg-[#FEE6E6] border border-[#C60302] rounded-[24px] p-7 sm:p-8 xl:p-10 min-h-[323px] flex flex-col justify-between overflow-hidden group hover:shadow-lg transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="100"
          >
            {/* Teks Kartu */}
            <div className="relative z-10 max-w-[320px] sm:max-w-[340px]">
              <h3 className="font-montserrat font-bold text-2xl sm:text-3xl lg:text-[38px] xl:text-[40px] text-[#202020] leading-[1.2] mb-4">
                Private Class <br />
                (1-on-1)
              </h3>
              <p className="font-montserrat font-normal text-sm sm:text-base lg:text-[19px] text-[#6A6A6A] leading-relaxed">
                Personalized learning experience with a dedicated tutor.
              </p>
            </div>

            {/* Tombol Learn More */}
            <div className="relative z-10 mt-8">
              <Link
                to="/course/Private"
                onClick={handleProtectedClick}
                className="inline-flex items-center gap-2.5 text-[#C60302] font-montserrat font-semibold text-lg sm:text-[20px] transition-transform duration-200 cursor-pointer"
              >
                <span>Learn More</span>
                <svg
                  className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1.5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>

            {/* Motif Abstrak 119 (Sisi Kanan) */}
            <div className="absolute right-0 top-0 bottom-0 h-full w-[220px] sm:w-[284px] pointer-events-none flex items-center justify-end overflow-hidden">
              <svg
                width="284"
                height="323"
                viewBox="0 0 284 323"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-full w-auto object-cover object-right"
              >
                <path
                  d="M131.67 219.236L72.438 276.823L131.67 334.41L190.903 276.823L131.67 219.236Z"
                  fill="url(#paint0_linear_22_305)"
                />
                <path
                  d="M250.239 219L191.006 276.587L250.239 334.174L309.471 276.587L250.239 219Z"
                  fill="url(#paint1_linear_22_305)"
                />
                <path
                  d="M132.134 104.647L72.9019 162.234L132.134 219.821L191.367 162.234L132.134 104.647Z"
                  fill="url(#paint2_linear_22_305)"
                />
                <path
                  d="M250.702 104.411L191.469 161.998L250.702 219.585L309.934 161.998L250.702 104.411Z"
                  fill="url(#paint3_linear_22_305)"
                />
                <path
                  d="M131.892 -10.6286L72.6597 46.9585L131.892 104.546L191.125 46.9585L131.892 -10.6286Z"
                  fill="url(#paint4_linear_22_305)"
                />
                <path
                  d="M250.461 -10.863L191.228 46.7241L250.461 104.311L309.693 46.7241L250.461 -10.863Z"
                  fill="url(#paint5_linear_22_305)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_22_305"
                    x1="102.054"
                    y1="248.029"
                    x2="159.618"
                    y2="307.238"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_22_305"
                    x1="220.623"
                    y1="247.794"
                    x2="278.187"
                    y2="307.003"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_22_305"
                    x1="102.518"
                    y1="133.44"
                    x2="160.082"
                    y2="192.649"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_22_305"
                    x1="221.086"
                    y1="133.205"
                    x2="278.65"
                    y2="192.413"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint4_linear_22_305"
                    x1="102.276"
                    y1="18.165"
                    x2="159.84"
                    y2="77.3739"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint5_linear_22_305"
                    x1="220.844"
                    y1="17.9306"
                    x2="278.409"
                    y2="77.1395"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>

          {/* ================= CARD 2: Semi Private Class ================= */}
          <div
            className="relative bg-[#FEE6E6] border border-[#C60302] rounded-[24px] p-7 sm:p-8 xl:p-10 min-h-[323px] flex flex-col justify-between overflow-hidden group hover:shadow-lg transition-all duration-300"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            {/* Teks Kartu */}
            <div className="relative z-10 max-w-[320px] sm:max-w-[340px]">
              <h3 className="font-montserrat font-bold text-2xl sm:text-3xl lg:text-[38px] xl:text-[40px] text-[#202020] leading-[1.2] mb-4">
                Semi Private <br />
                Class
              </h3>
              <p className="font-montserrat font-normal text-sm sm:text-base lg:text-[19px] text-[#6A6A6A] leading-relaxed">
                Collaborative learning environment with a small group of students.
              </p>
            </div>

            {/* Tombol Learn More */}
            <div className="relative z-10 mt-8">
              <Link
                to="/course/semiPrivate"
                onClick={handleProtectedClick}
                className="inline-flex items-center gap-2.5 text-[#C60302] font-montserrat font-semibold text-lg sm:text-[20px] transition-transform duration-200 cursor-pointer"
              >
                <span>Learn More</span>
                <svg
                  className="w-6 h-6 transition-transform duration-300 group-hover:translate-x-1.5"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                  <polyline points="12 5 19 12 12 19"></polyline>
                </svg>
              </Link>
            </div>

            {/* Motif Abstrak 224 (Sisi Kanan) */}
            <div className="absolute right-0 top-0 bottom-0 h-full w-[220px] sm:w-[286px] pointer-events-none flex items-center justify-end overflow-hidden">
              <svg
                width="286"
                height="323"
                viewBox="0 0 286 323"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="h-full w-auto object-cover object-right"
              >
                <path
                  d="M75.2729 -8.00488C75.2729 38.9407 114.387 76.998 162.637 76.998C162.637 30.0524 123.523 -8.00488 75.2729 -8.00488Z"
                  fill="url(#paint0_linear_22_316)"
                />
                <path
                  d="M162.637 76.998C114.387 76.998 75.2729 115.055 75.2729 162.001C123.523 162.001 162.637 123.944 162.637 76.998Z"
                  fill="url(#paint1_linear_22_316)"
                />
                <path
                  d="M250 -8.00488C201.75 -8.00488 162.637 30.0524 162.637 76.998C210.887 76.998 250 38.9417 250 -8.00488Z"
                  fill="url(#paint2_linear_22_316)"
                />
                <path
                  d="M75.2729 332.005C123.523 332.005 162.637 293.949 162.637 247.003C114.387 247.003 75.2729 285.059 75.2729 332.005Z"
                  fill="url(#paint3_linear_22_316)"
                />
                <path
                  d="M162.637 247.003C162.637 293.949 201.75 332.005 250 332.005C250 285.059 210.887 247.003 162.637 247.003Z"
                  fill="url(#paint4_linear_22_316)"
                />
                <path
                  d="M250 162C250 115.054 210.886 76.9971 162.636 76.9971C162.636 123.943 201.75 162 250 162C201.75 162 162.636 200.056 162.636 247.002C162.636 200.056 123.521 162 75.2719 162C75.2719 208.946 114.386 247.002 162.636 247.002C210.886 247.002 250 208.946 250 162Z"
                  fill="url(#paint5_linear_22_316)"
                />
                <path
                  d="M337.363 76.998C337.363 30.0524 298.25 -8.00488 250 -8.00488C250 38.9407 289.113 76.998 337.363 76.998Z"
                  fill="url(#paint6_linear_22_316)"
                />
                <path
                  d="M250 162C298.25 162 337.363 123.943 337.363 76.9971C289.113 76.9971 250 115.054 250 162Z"
                  fill="url(#paint7_linear_22_316)"
                />
                <path
                  d="M250 332.005C298.25 332.005 337.363 293.949 337.363 247.003C289.113 247.003 250 285.059 250 332.005Z"
                  fill="url(#paint8_linear_22_316)"
                />
                <path
                  d="M424.727 162C376.477 162 337.363 200.056 337.363 247.002C337.363 200.056 298.25 162 250 162C250 208.946 289.113 247.002 337.363 247.002C385.613 247.002 424.727 208.946 424.727 162Z"
                  fill="url(#paint9_linear_22_316)"
                />
                <defs>
                  <linearGradient
                    id="paint0_linear_22_316"
                    x1="118.955"
                    y1="-8.00488"
                    x2="118.955"
                    y2="76.998"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint1_linear_22_316"
                    x1="118.955"
                    y1="76.998"
                    x2="118.955"
                    y2="162.001"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint2_linear_22_316"
                    x1="206.319"
                    y1="-8.00488"
                    x2="206.319"
                    y2="76.998"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint3_linear_22_316"
                    x1="118.955"
                    y1="247.003"
                    x2="118.955"
                    y2="332.005"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint4_linear_22_316"
                    x1="206.318"
                    y1="247.003"
                    x2="206.318"
                    y2="332.005"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint5_linear_22_316"
                    x1="162.636"
                    y1="76.9971"
                    x2="162.636"
                    y2="247.003"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint6_linear_22_316"
                    x1="293.682"
                    y1="-8.00488"
                    x2="293.682"
                    y2="76.998"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint7_linear_22_316"
                    x1="293.682"
                    y1="76.9971"
                    x2="293.682"
                    y2="162"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint8_linear_22_316"
                    x1="293.682"
                    y1="247.003"
                    x2="293.682"
                    y2="332.005"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                  <linearGradient
                    id="paint9_linear_22_316"
                    x1="337.364"
                    y1="162"
                    x2="337.364"
                    y2="247.003"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stopColor="#C60302" />
                    <stop offset="1" stopColor="#FEE6E6" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LanguageCourses;
